import { render, staticRenderFns } from "./FaTop.vue?vue&type=template&id=07c9f220&scoped=true"
import script from "./FaTop.vue?vue&type=script&lang=js"
export * from "./FaTop.vue?vue&type=script&lang=js"
import style0 from "./FaTop.vue?vue&type=style&index=0&id=07c9f220&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07c9f220",
  null
  
)

export default component.exports